module.exports = __webpack_public_path__ + "static/media/AdobeStock_295693279_RED.1ecd1dd0.webp";